import SubscriptionSettingsPage from "./subscription-settings";
import "./subscription-settings.scss";

export default SubscriptionSettingsPage;
